<template>
  <div>
    <b-field
      :label="$t('name_label')"
      :type="{ 'is-danger': errors.name }"
      :message="errors.name ? errors.name[0] : ''"
      :custom-class="errors.name ? 'has-text-danger' : ''">
      <b-input type="text" :placeholder="$t('name_placeholder')"
        v-model="formData.name" :value="formData.name" required />
    </b-field>

    <b-field
      v-if="formData.logo === null"
      :type="{ 'is-danger': errors.logo }"
      :message="errors.logo ? errors.logo[0] : ''"
      :custom-class="errors.logo ? 'has-text-danger' : ''">
      <b-upload v-model="formData.logo" accept=".png, .jpg, .jpeg, .gif">
        <a class="button is-primary">
          <b-icon icon="upload" />
          <span v-t="'logo_upload_button'" />
        </a>
      </b-upload>
    </b-field>

    <span v-else class="tag is-primary is-large">
      {{ formData.logo.name }}&nbsp;
      <button class="delete is-small" type="button" @click="removeFile()" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProductsForm',
  props: {
    product: { type: Object, required: true },
    errors: Object
  },
  data () {
    return {
      formData: {
        name: '',
        logo: null
      }
    }
  },
  mounted () {
    this.formData = this.product
  },
  methods: {
    removeFile () {
      this.formData.logo = null
    }
  },
  watch: {
    product () {
      this.formData = this.product
    },
    formData () {
      this.$emit('update:product', this.formData)
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "name_label": "Name",
    "name_placeholder": "Product name",
    "logo_upload_button": "Upload logo"
  },
  "pt-BR": {
    "name_label": "Nome",
    "name_placeholder": "Nome do produto",
    "logo_upload_button": "Enviar um logotipo"
  }
}
</i18n>
